import { Download, Users } from "lucide-react";
import { APP_DOWNLOAD_URL } from "../config";
import { Reveal } from "./Reveal";

export default function Referral() {
  return (
    <section className="relative py-20 sm:py-24 border-t border-white/[0.06]" data-testid="referral-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#0B0B0F] p-8 sm:p-12">
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_80%_50%,rgba(212,175,55,0.08),transparent_60%)]" aria-hidden="true" />

            <div className="relative grid items-center gap-10 md:grid-cols-[1fr_auto]">
              <div>
                <div className="flex items-center gap-3">
                  <Users className="h-4 w-4 text-[#D4AF37]" />
                  <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37] uppercase">Referral Program</span>
                </div>
                <h2 className="mt-4 font-display text-3xl sm:text-4xl font-bold tracking-tight text-white">
                  Earn With Your Community
                </h2>
                <p className="mt-4 max-w-xl text-base leading-relaxed text-[#99A1AF]">
                  Invite your network to Winter Protocol and earn through the referral infrastructure
                  built into the ecosystem.
                </p>
              </div>

              <div className="flex flex-col items-start md:items-end gap-5">
                <div>
                  <span className="font-display text-6xl sm:text-7xl font-extrabold tracking-tight text-gold-gradient" data-testid="referral-commission-figure">
                    25%
                  </span>
                  <p className="mt-2 font-mono text-[11px] tracking-[0.28em] text-[#99A1AF] uppercase md:text-right">
                    Referral Commission
                  </p>
                </div>
                <a
                  href={APP_DOWNLOAD_URL}
                  download="winter-protocol.apk"
                  data-testid="referral-download-button"
                  className="group inline-flex items-center gap-2.5 rounded-full border border-[#D4AF37]/40 px-7 py-3 text-sm font-medium text-[#F3E5AB] transition-all duration-300 hover:bg-[#D4AF37]/10 hover:border-[#D4AF37]/70"
                >
                  <Download className="h-4 w-4" />
                  Download App to Start
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
